module.exports = __webpack_public_path__ + "static/img/首页图片1.7d3638e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/首页图片1.jpg
// module id = r9oK
// module chunks = 1